import {put, takeEvery, all, call} from 'redux-saga/effects';
import urls from '@src/configs/web.config';
import * as actions from '@src/actions/index';

const {goLoginURl} = urls;

// 获取用户信息
function* watchUserInfo() {
  yield takeEvery(actions.getUserInfoSagaAction().type, function* getUserInfo() {
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/system/common/initMycData`
    const userInfo = yield call(() =>
      fetch(url, {method: 'get'})
        .catch((error) => {
          return {
            "preferred_username": "",
            "name": "",
            "given_name": "",
            "family_name": "",
            "email": "",
            "tenantid": "",
            "accountid": "",
            "realmRole": "",
            "roles": [],
            "displayName": "",
            "displayName_En": ""
          };
        })
    );
    if (userInfo.canSeeRoma == true) {
      sessionStorage.setItem('canSeeRoma', userInfo.canSeeRoma)
    } else {
      sessionStorage.removeItem('canSeeRoma')
    }
    let usersMsg = {
      "preferred_username": "",
      "name": "",
      "given_name": "",
      "family_name": "",
      "email": "",
      "tenantid": "",
      "accountid": "",
      "realmRole": "",
      "roles": [],
      "displayName": "",
      "displayName_En": ""
    };
    let userInfoRep = userInfo.currUser.ssoUser || usersMsg;
    if (!userInfo.currUser.account) {
      window.location.href = goLoginURl(window.location.href);
    }
    yield put(actions.getUserInfoAction({
      ...userInfoRep,
      isAdmin: userInfo.isAdmin,
      canSeeRoma: userInfo.canSeeRoma,
      isAllAppStoreAdmin: "isAllAppStoreAdmin" in userInfo ? userInfo.isAllAppStoreAdmin: true,
    }));
    yield put(actions.getUserReady());
  });
}

// 获取服务商信息
function* watchTenantInfo() {

  yield takeEvery(actions.getTenantCheckisv().type, function* getTenantIsv() {
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/tenant/checkIsv`
    let tenantIsv = yield call(() =>
      fetch(url, {method: 'get'}).catch((error) => {
        return {};
      })
    );
    //  ISV 推广
    if (tenantIsv.status == 1) {
      let data = tenantIsv.data
      if (data.isv == 1) {
        sessionStorage.setItem('ISVVALUE', data.isv)
      } else {
        sessionStorage.removeItem('ISVVALUE')
      }
    }
  })

  yield takeEvery(actions.getTenantInfoSagaAction().type, function* getTenantInfo() {
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/tenant/tenantInfo`
    let tenantInfo = yield call(() =>
      fetch(url, {method: 'get'}).catch((error) => {
        return {};
      })
    );
    if (tenantInfo.status == 0) {
      tenantInfo = {data: {}};
    }
    yield put(actions.getTenantInfoAction(tenantInfo.data));
    yield put(actions.getGlobalDataSagaAction());
  });


}

function* getSiteTypeInfo() {
  yield takeEvery(actions.getSiteTypeSagaAction().type, function* getSiteType() {
    let url = `/${process.env.REACT_APP_API_CONTEXT}/service/system/common/sub-site/v1/sites?action=current`
    let siteType = yield call(() =>
      fetch(url, {method: 'get'}).catch((error) => {
        return {data: {site_type: 2}};
      })
    );
    if (siteType.status == 0) {
      siteType = {data: {site_type: 2}};
    }
    yield put(actions.getSiteTypeAction(siteType.data));
    yield put(actions.getSiteReady());
  });
}

function* watchNavMenuList() {
  // takeEvery 监听 action，用请参考https://redux-saga-in-chinese.js.org/docs/advanced/FutureActions.html
  yield takeEvery(actions.getGlobalDataSagaAction().type, function* getGlobalData() {
    try {
      // 同时执行多个任务
      const licenseReq = null;
      // 预请求服务完毕
      yield put(actions.getReady());

    } catch (e) {
    }
  });
}

export default function* rootSaga() {
  yield all([watchUserInfo(), getSiteTypeInfo(), watchTenantInfo(), watchNavMenuList()]);
}
